import * as Yup from "yup";

export class IntegerValidator {
  static validationSchema = Yup.number().nullable()
  .required("Pole jest wymagane")
  .typeError("Wartość pola musi być liczbą")
  .positive("Wartość pola musi być większa od zera")
  .integer("Wartość pola musi być liczbą całkowitą");
}